/**
 * Pure rules for RSVP write behaviour after submit (mirrors RSVPPage submit path).
 */

export function optionalRsvpUserIdFields(userId: string | undefined): { userId?: string } {
  if (!userId) {
    return {};
  }
  return { userId };
}

/**
 * Invoice creation runs only for logged-in guests paying for themselves after a standard RSVP.
 */
export function shouldCreateInvoiceAfterStandardRsvp(params: {
  isInterestOnly: boolean;
  apology: boolean;
  userId: string | undefined;
  inviterPaysForGuest: boolean;
}): boolean {
  if (params.isInterestOnly || params.apology) {
    return false;
  }
  if (!params.userId) {
    return false;
  }
  if (params.inviterPaysForGuest) {
    return false;
  }
  return true;
}
